<template>
  <div class="pt-2">
    <div class="row mx-0" v-if="isStartRecording === false && !isRetakeEnabled && !isPauseVideo">
      <div class="col-12">
        <div class="feedback-header">
          <p>Camera Preview</p>
        </div>
      </div>
    </div>
    <div class="row mx-0" v-if="isStartRecording === true || isPauseVideo">
      <div class="col-12">
        <div class="feedback-header">
          <p>Recording</p>
        </div>
      </div>
    </div>
    <div class="row mt-3 mx-0">
      <div class="col-12">
        <div class="panel">
          <h5 class="title-head d-flex align-items-center justify-content-center" v-if="isStartRecording === false && !isRetakeEnabled && !isPauseVideo">
            <div class="icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <path d="M0.5 7C0.224 7 0 6.776 0 6.5V4.5C0 3.122 1.121 2 2.5 2H4.5C4.776 2 5 2.224 5 2.5C5 2.776 4.776 3 4.5 3H2.5C1.673 3 1 3.673 1 4.5V6.5C1 6.776 0.776 7 0.5 7Z" fill="#FF077B" />
                  <path d="M23.5 7C23.224 7 23 6.776 23 6.5V4.5C23 3.673 22.327 3 21.5 3H19.5C19.224 3 19 2.776 19 2.5C19 2.224 19.224 2 19.5 2H21.5C22.879 2 24 3.122 24 4.5V6.5C24 6.776 23.776 7 23.5 7Z" fill="#FF077B" />
                  <path d="M4.5 22H2.5C1.121 22 0 20.878 0 19.5V17.5C0 17.224 0.224 17 0.5 17C0.776 17 1 17.224 1 17.5V19.5C1 20.327 1.673 21 2.5 21H4.5C4.776 21 5 21.224 5 21.5C5 21.776 4.776 22 4.5 22Z" fill="#FF077B" />
                  <path d="M21.5 22H19.5C19.224 22 19 21.776 19 21.5C19 21.224 19.224 21 19.5 21H21.5C22.327 21 23 20.327 23 19.5V17.5C23 17.224 23.224 17 23.5 17C23.776 17 24 17.224 24 17.5V19.5C24 20.878 22.879 22 21.5 22Z" fill="#FF077B" />
                  <path
                    d="M12 18C8.147 18 4.864 15.582 4.015 12.119C3.995 12.041 3.995 11.959 4.015 11.881C4.864 8.418 8.147 6 12 6C15.853 6 19.136 8.418 19.985 11.881C20.005 11.959 20.005 12.041 19.985 12.119C19.136 15.582 15.853 18 12 18ZM5.016 12C5.802 14.95 8.655 17 12 17C15.345 17 18.198 14.95 18.984 12C18.198 9.05 15.346 7 12 7C8.654 7 5.802 9.05 5.016 12Z"
                    fill="#FF077B"
                  />
                  <path d="M12 15C10.346 15 9 13.654 9 12C9 10.346 10.346 9 12 9C13.654 9 15 10.346 15 12C15 13.654 13.654 15 12 15ZM12 10C10.897 10 10 10.897 10 12C10 13.103 10.897 14 12 14C13.103 14 14 13.103 14 12C14 10.897 13.103 10 12 10Z" fill="#FF077B" />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            Camera Preview: Not yet recording.
          </h5>
          <h5 class="title-head d-flex align-items-center justify-content-center" v-if="isStartRecording === true || isPauseVideo">
            <div class="icon">
              <svg width="51" height="50" viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <path d="M11.0286 21.6113H9.83337V23.8566H11.0285C11.7045 23.8566 12.1149 23.5789 12.1149 22.734C12.115 21.8889 11.7045 21.6113 11.0286 21.6113Z" fill="#FF077B" />
                  <path d="M38.0508 21.8213C36.5504 21.8213 35.3297 23.0419 35.3297 24.5423C35.3297 26.0427 36.5504 27.2634 38.0508 27.2634C39.5512 27.2634 40.7719 26.0427 40.7719 24.5423C40.7719 23.0419 39.5512 21.8213 38.0508 21.8213Z" fill="#FF077B" />
                  <path
                    d="M47.8633 12.6357H3.13672C1.68281 12.6357 0.5 13.8186 0.5 15.2725V34.7274C0.5 36.1813 1.68281 37.3641 3.13672 37.3641H47.8633C49.3172 37.3641 50.5 36.1813 50.5 34.7274V15.2725C50.5 13.8186 49.3172 12.6357 47.8633 12.6357ZM12.8876 28.8657C12.6461 28.8657 12.4168 28.7692 12.284 28.5157L10.6302 25.3047H9.8334V28.2139C9.8334 28.6002 9.3627 28.7934 8.8918 28.7934C8.42109 28.7934 7.9502 28.6002 7.9502 28.2139V20.5365C7.9502 20.2348 8.17959 19.969 8.52969 19.969H11.0285C12.6823 19.969 13.998 20.5848 13.998 22.5523C13.998 23.9045 13.3823 24.6769 12.5374 25.0029L14.0101 27.6707C14.0584 27.7431 14.0704 27.8276 14.0704 27.888C14.0705 28.3588 13.4428 28.8657 12.8876 28.8657ZM18.694 23.6511C19.0562 23.6511 19.2614 24.0011 19.2614 24.3873C19.2614 24.7133 19.0925 25.0995 18.694 25.0995H16.8833V27.1516H20.1185C20.4807 27.1516 20.6859 27.5381 20.6859 27.9845C20.6859 28.371 20.5169 28.7934 20.1185 28.7934H15.8211C15.4106 28.7934 15.0002 28.6002 15.0002 28.2139V20.5485C15.0002 20.1623 15.4106 19.969 15.8211 19.969H20.1185C20.5168 19.969 20.6859 20.3917 20.6859 20.7779C20.6859 21.2246 20.4807 21.6108 20.1185 21.6108H16.8833V23.651H18.694V23.6511ZM24.3072 27.224C25.273 27.224 25.3334 26.4878 25.3695 26.0169C25.4058 25.5704 25.8162 25.4496 26.299 25.4496C26.9509 25.4496 27.2526 25.6185 27.2526 26.3429C27.2526 27.9484 25.9489 28.8657 24.2228 28.8657C22.6415 28.8657 21.3257 28.0932 21.3257 26.0169V22.8181C21.3257 20.7417 22.6415 19.969 24.2228 19.969C25.949 19.969 27.2526 20.8382 27.2526 22.3714C27.2526 23.0956 26.9509 23.2645 26.311 23.2645C25.8041 23.2645 25.3936 23.1318 25.3694 22.6973C25.3574 22.3833 25.3212 21.6108 24.2951 21.6108C23.607 21.6108 23.2087 21.9971 23.2087 22.818V26.0168C23.2088 26.8378 23.6071 27.224 24.3072 27.224ZM38.0508 30.1937C34.935 30.1937 32.4 27.6588 32.4 24.543C32.4 21.4271 34.935 18.8923 38.0508 18.8923C41.1666 18.8923 43.7016 21.4271 43.7016 24.543C43.7016 27.6588 41.1666 30.1937 38.0508 30.1937Z"
                    fill="#FF077B"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="50" height="50" fill="white" transform="translate(0.5)" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <span id="current-recording">00:00</span>
          </h5>
          <div class="video-frame live-streamings">
            <video ref="videoPlayer" data-setup="{controls:false}" class="video-js vjs-default-skin"></video>
          </div>
          <div class="detail">
            <p class="subtitle" v-if="isStartRecording === false && !isRetakeEnabled && !isPauseVideo">You can watch and re-record any video you don’t like before submitting.</p>
            <button class="btn btn-solid" @click.prevent="startRecording()" v-if="isStartRecording === false && !isRetakeEnabled && !isPauseVideo" id="btnStart">
              <div class="icon">
                <svg width="25" height="24" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.5 6C9.18802 6 6.5 8.68802 6.5 12C6.5 15.312 9.18802 18 12.5 18C15.812 18 18.5 15.312 18.5 12C18.5 8.68796 15.812 6 12.5 6Z" />
                  <path
                    d="M12.5 0C5.87001 0 0.5 5.37001 0.5 12C0.5 18.6299 5.87001 23.9999 12.5 23.9999C19.1299 23.9999 24.5 18.63 24.5 12C24.5 5.36996 19.13 0 12.5 0ZM12.5 21.6C7.19599 21.6 2.89996 17.304 2.89996 12C2.89996 6.69594 7.19599 2.40002 12.5 2.40002C17.8039 2.40002 22.1 6.69599 22.1 12C22.1 17.3039 17.804 21.6 12.5 21.6Z"
                  />
                </svg>
              </div>
              Start Recording
            </button>
            <div class="options d-flex align-items-center justify-content-center">
              <div class="option-item btn d-sm-flex align-items-center justify-content-center hollow-btn" @click.prevent="stopRecording()" v-if="isStartRecording === true && !isPauseVideo" id="btnStop">
                <svg width="25" height="24" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.5 19H10.5V5H6.5V19ZM14.5 5V19H18.5V5H14.5Z" />
                </svg>
                <p class="mb-0">Pause</p>
              </div>
              <div class="option-item btn d-sm-flex align-items-center justify-content-center hollow-btn" @click.prevent="stopRecording()" v-if="!isStartRecording === true && isPauseVideo" id="btnStop">
                <svg width="24" height="24" viewBox="0 0 24 24" style="fill: var(--action-btn-color)" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 5V19L19 12L8 5Z" fill="" fill-opacity="0.87" />
                </svg>
                <p class="mb-0">Resume</p>
              </div>
              <div class="option-item btn d-sm-flex align-items-center justify-content-center" @click.prevent="endRecording()" v-if="isStartRecording === true || isPauseVideo" id="btnStop">
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 6H18V18H6V6Z" />
                </svg>
                <p class="mb-0">Stop</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "videojs-record/dist/css/videojs.record.css";
import "webrtc-adapter";
import RecordRTC from "recordrtc";
import Record from "videojs-record/dist/videojs.record.js";
// import FFmpegjsEngine from 'videojs-record/dist/plugins/videojs.record.ffmpegjs.js';
export default {
  props: ["uploadUrl", "deviceInfo" , "recordWithoutAudio"],
  data() {
    return {
      player: "",
      retake: 0,
      currentQuestion: "",
      currentOption: "",
      isSaveDisabled: true,
      isStartRecording: false,
      isRetakeEnabled: false,
      isSubmitVideo: false,
      isPauseVideo: false,
      submitText: "Submit",
      options: {
        controls: true,
        bigPlayButton: false,
        controlBar: {
          deviceButton: false,
          recordToggle: false,
          pipToggle: false,
        },
        width: 800,
        height: 300,
        fluid: true,
        plugins: {
          record: {
            pip: true,
            audio: true,
            video: {
              deviceId: { exact: "" },
            },
            debug: true,
          },
        },
      },
      mediaSream:null
    };
  },
  created() {
    this.$helpers.updateColorAccordingApi();
    this.options.plugins.record.video.deviceId.exact = this.deviceInfo.deviceId;
    if(!this.recordWithoutAudio) {
    this.options.plugins.record.audio = false;
    }
  },
  mounted() {
    this.$helpers.resizeIframeEvent();
    this.currentQuestion = this.$session.get("currtenQuestion");
    this.currentOption = this.$session.get("currentOption");
    if (this.currentOption.recording_settings.allow_max_recording === 1) {
      this.options.plugins.record.maxLength = this.currentOption.recording_settings.max_minutes * 60 + this.currentOption.recording_settings.max_seconds;
    } else {
      this.options.plugins.record.maxLength = 3600;
    }
    this.player = videojs(this.$refs.videoPlayer, this.options, () => {
      var msg = "Using video.js " + videojs.VERSION + " with videojs-record " + videojs.getPluginVersion("record") + " and recordrtc " + RecordRTC.version;
      console.log(msg, Record);
      videojs.log();
    });
    this.player.on("deviceReady", () => {
      this.player.record().start();
      setInterval(() => {
        if (document.getElementById("current-recording")) {
          document.getElementById("current-recording").innerHTML = document.getElementsByClassName("vjs-current-time-display")[0].innerHTML;
        }
      }, 400);
    });
    this.player.on("deviceError", () => {
      console.log("device error:", this.player.deviceErrorCode);
    });
    this.player.on("error", (element, error) => {
      console.error(error);
    });
    this.player.on("startRecord", () => {});
    this.player.on("finishRecord", () => {
      this.isSaveDisabled = false;
      if (this.retake == 0) {
        this.isRetakeDisabled = false;
      }
      this.$session.set("recordedData", this.player.recordedData);
      this.submitVideo();
    });
    this.startStreaming();
    window.addEventListener(
      "message",
      (event) => {
        if (event.origin === "http://localhost:8100" || event.origin === "https://vkstg.larkbase.com" || event.origin === "https://app.vouchkick.com") {
          if (event.data.settings) {
            for (let key in event.data.settings) {
              this.response.settings[key] = event.data.settings[key];
            }
            this.$session.set("response", this.response);
            var this_pointer = this;
            setTimeout(function() {
              this_pointer.$helpers.resizeIframeEvent();
            }, 300);
          }
        }
      },
      false
    );
  },
  methods: {
    cancleVideo() {
      this.$emit("close");
    },
    startRecording() {
      this.isStartRecording = true;
      if (this.isPauseVideo) {
        this.player.record().resume();
      } else {
        this.player.record().getDevice();
      }
      this.isSubmitVideo = false;
    },
    submitVideo() {
      this.isSaveDisabled = true;
      this.isRetakeEnabled = false;
      this.$emit("clicked", this.player.recordedData);
    },
    retakeVideo() {
      this.isSaveDisabled = true;
      this.isRetakeEnabled = false;
      this.retake += 1;
      this.player.record().start();
      this.isSubmitVideo = false;
    },
    stopRecording() {
      if (this.isPauseVideo) {
        this.player.record().resume();
        this.isPauseVideo = false;
        this.isStartRecording = true;
      } else {
        this.player.record().pause();
        this.isPauseVideo = true;
        this.isStartRecording = false;
      }
      this.isRetakeEnabled = false;
      this.isSubmitVideo = false;
    },
    endRecording() {
      this.isStartRecording = false;
      this.player.record().stop();
      this.isSubmitVideo = true;
      this.isPauseVideo = false;
      this.submitVideo();
    },
    startStreaming() {
      var mediaSupport = "mediaDevices" in navigator;
      if (mediaSupport) {
        navigator.mediaDevices
          .getUserMedia({ video: true })
          .then((mediaStream) => {
            // this.cameraStream = mediaStream;
            this.mediaSream = mediaStream;
            this.$refs.videoPlayer.srcObject = mediaStream;
            this.$refs.videoPlayer.play();
          })
          .catch((err) => {
            console.log("Unable to access camera: " + err);
          });
      } else {
        alert("Your browser does not support media devices.");

        return;
      }
    },
  },
  beforeDestroy() {
    if (this.player) {
      
      const track = this.mediaSream.getVideoTracks()[0];
      track.stop();

      this.player.dispose();
    }
  },
};
</script>
<style>
/* .vjs-control-bar, .vjs-record-indicator {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
} */
#current-recording {
  width: 70px;
}
.live-streamings .vjs-control-bar,
.vjs-record-indicator {
  display: none !important;
}
</style>
<style scoped lang="scss">
// .video-js .vjs-control-bar .vjs-control {
//   display: none !important;
// }
.feedback-header {
  border-radius: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;

  p {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.01em;
    color: var(--title-color);
    margin: 0;
    margin-left: 8px;
  }
}
.detail {
  margin-top: 16px;
  .title {
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.01em;
    color: #313c4e;
    margin-bottom: 16px;
  }
  .subtitle {
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    letter-spacing: 0.01em;
    color: #56657f;
    margin-bottom: 0px;
  }

  .btn {
    width: 100%;
    height: 50px;
    margin-top: 32px;
  }
}
.title-head {
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.01em;
  color: var(--accent-color);
  margin-bottom: 16px;

  .icon {
    margin-right: 4px;
    fill: var(--action-btn-color);
  }
}
.back-btn {
  margin-bottom: 35px;
  background: none;
  .icon {
    margin-right: 8px;
    fill: var(--action-btn-color);
  }
  .text {
    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #56657f;
    }
  }
}
.copyright {
  display: flex;
  align-items: flex-end;
  margin-bottom: 15px;
  padding: 4px 11px;
  background: #fff;
  margin-bottom: 15px;
  border-radius: 40px;
  .icon {
    margin-right: 4.84px;
    display: flex;
    align-items: flex-end;
    padding-bottom: 3px;
  }
  .text {
    p {
      font-family: "Mulish", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 15px;
      color: #8997b1;
    }
  }
}
a {
  text-decoration: none;
}
.options {
  .option-item {
    background: var(--accent-color);
    border-radius: 5px;
    width: 100%;
    height: 50px;
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;

    input {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }

    &:last-child {
      margin-right: 0px;
    }

    svg {
      margin-right: 8px;
      fill: var(--action-btn-color);
    }

    .upload-style {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      text-align: center;
      letter-spacing: 0.01em;
      color: var(--action-btn-color);
    }

    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      text-align: center;
      letter-spacing: 0.01em;
      color: var(--action-btn-color);
    }
  }
  .hollow-btn {
    background: white;
    color: var(--accent-color);
    border: 1px solid var(--accent-color);
    &:hover {
      color: var(--accent-color) !important;
    }
    p {
      color: var(--accent-color);
    }
    svg {
      fill: var(--accent-color);
    }
  }
}
</style>
